import React from 'react';
import cn from 'classnames';
import { Button } from 'swag-client-common/components/ui/button';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { Placement } from 'swag-client-common/constants';
import classes from '../cart-item/cart-item.scss';
const tooltipStyles = {
  popper: classes.boxEditBtnTooltipPopper,
  tooltip: classes.tooltipRoot
};
const BoxControlButtons = ({
  boxId,
  isSavedForLater,
  tooltipText,
  onEditBoxClick,
  onAddProductsClick
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: cn(classes.buttonsWrapper)
  }, isSavedForLater ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipText,
    placement: Placement.RIGHT,
    mode: "light",
    className: classes.infoWrapper,
    classes: tooltipStyles
  }, /*#__PURE__*/React.createElement(Button, {
    dataButton: "EditBox",
    type: "secondary",
    className: cn(classes.editBox, classes.disabledBoxBtn)
  }, "Edit Box")), /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipText,
    placement: Placement.RIGHT,
    mode: "light",
    className: classes.infoWrapper,
    classes: tooltipStyles
  }, /*#__PURE__*/React.createElement(Button, {
    dataButton: "AddProducts",
    type: "primary",
    className: cn(classes.addProducts, classes.disabledBoxBtn)
  }, "Add Products"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    dataButton: "EditBox",
    type: "secondary",
    className: classes.editBox,
    onClick: () => onEditBoxClick(boxId)
  }, "Edit Box"), /*#__PURE__*/React.createElement(Button, {
    dataButton: "AddProducts",
    type: "primary",
    className: classes.addProducts,
    onClick: () => onAddProductsClick(boxId)
  }, "Add Products")));
};
export default BoxControlButtons;